import React from 'react'
import { Link } from 'gatsby'
import styles from './header.module.scss'

import Navigation from './navigation'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = { navOpen: false, scrolled: false }
    this.openNav = this.openNav.bind(this)
  }

  openNav() {
    this.setState({
      navOpen: !this.state.navOpen,
    })
  }

  render() {
    return (
      <>
        <header className={`${styles.header} `}>
          <span className={`${styles.navigation}`}>
            <Navigation location={this.props.location.pathname} />
          </span>
          <button className={styles.button} onClick={this.openNav}>
            <div
              className={
                this.state.navOpen === true
                  ? `hamburger is-active`
                  : this.props.location.pathname == '/'
                    ? 'hamburger is active hamburger--white'
                    : `hamburger`
              }
              id="hamburger-1"
            >
              <span
                className={
                  this.state.navOpen === true
                    ? ` line ${styles.lineWhite}`
                    : 'line'
                }
              />
              <span
                className={
                  this.state.navOpen === true
                    ? ` line ${styles.lineWhite}`
                    : 'line'
                }
              />
              <span
                className={
                  this.state.navOpen === true
                    ? ` line ${styles.lineWhite}`
                    : 'line'
                }
              />
            </div>
          </button>
        </header>
        <div
          className={
            this.state.navOpen === true
              ? `${styles.mobNav}`
              : `${styles.mobNavHidden}`
          }
        >
          <Navigation mobile={true} />
        </div>
      </>
    )
  }
}

export default Header
